import { render, staticRenderFns } from "./tag-listing-editor.vue?vue&type=template&id=205f9940&scoped=true&"
import script from "./tag-listing-editor.vue?vue&type=script&lang=js&"
export * from "./tag-listing-editor.vue?vue&type=script&lang=js&"
import style0 from "./tag-listing-editor.vue?vue&type=style&index=0&id=205f9940&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "205f9940",
  null
  
)

export default component.exports